import React from "react";

const Bash_Loops = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Loops</h2>
      <p>Loop constructs: for, while, until.</p><pre><code>for f in *.txt; do
  echo "$f"
done

count=0
while [[ $count -lt 5 ]]; do
  echo $count
  ((count++))
done</code></pre>
    </div>
  );
};

export default Bash_Loops;
